export const months = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December'
];

export const days = [
    'Sunday',
    'Monday',
    'Tuesday',
    'Wednesday',
    'Thursday',
    'Friday',
    'Saturday'
];

export const years = getYearsRange(2020, 20);

export function getAllDaysInMonth(days, year, month) {
    const result = [];
    for (let i = 0; i < days; i++) {
        result.push(new Date(year, month - 1, i + 1));
    }
    return result;
}

export function getDaysInMonth(date) {
    const { year, month } = getFormattedDate(date);
    const daysInMonths = new Date(year, month, 0).getDate();
    const currentMonth = getAllDaysInMonth(daysInMonths, year, month);
    let previousMonth;
    let nextMonth;

    if (month === 1) {
        previousMonth = getAllDaysInMonth(
            new Date(year - 1, 12, 0).getDate(),
            year - 1,
            12
        );
        nextMonth = getAllDaysInMonth(new Date(year, 2, 0).getDate(), year, 2);
    } else if (month === 12) {
        nextMonth = getAllDaysInMonth(
            new Date(year + 1, 1, 0).getDate(),
            year + 1,
            1
        );
        previousMonth = getAllDaysInMonth(
            new Date(year, 11, 0).getDate(),
            year,
            11
        );
    } else {
        previousMonth = getAllDaysInMonth(
            new Date(year, month - 1, 0).getDate(),
            year,
            month - 1
        );
        nextMonth = getAllDaysInMonth(
            new Date(year, month + 1, 0).getDate(),
            year,
            month + 1
        );
    }

    let fullMonthWithPrev = [];
    if (currentMonth[0].getDay() !== 1) {
        let cutDaysFromPrevMonth =
            currentMonth[0].getDay() === 0 ? 6 : currentMonth[0].getDay() - 1;
        let prevDays = previousMonth.slice(
            previousMonth.length - cutDaysFromPrevMonth
        );
        fullMonthWithPrev = prevDays.concat(currentMonth);
    } else {
        fullMonthWithPrev = currentMonth;
    }

    if (currentMonth[currentMonth.length - 1].getDay() !== 0) {
        let cutDaysFromNextMonth =
            7 - currentMonth[currentMonth.length - 1].getDay();
        let nextDays = nextMonth.slice(0, cutDaysFromNextMonth);
        fullMonthWithPrev = fullMonthWithPrev.concat(nextDays);
    }

    return fullMonthWithPrev;
}

export function getYearsRange(start, length) {
    const year = new Date(start, 0, 0).getFullYear();
    return Array.from(new Array(length), (v, idx) => year + idx);
}

export function getFormattedDate(date = new Date()) {
    return {
        date: date.getDate(),
        month: date.getMonth() + 1,
        year: date.getFullYear()
    };
}

export function formatDate(date, local) {
    return new Intl.DateTimeFormat(local, {
        dateStyle: 'long'
    }).format(new Date(date));
}

export function compareFormattedDates(first, second) {
    return (
        first.date === second.date &&
        first.month === second.month &&
        first.year === second.year
    );
}
